import { useMemo } from 'react'

import { faArchive, faFile, faFileDoc, faFileExcel, faFilePdf, faImage, faMinus, faTimes } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import IconButton from '../antd/Buttons/IconButton'
import { FileTypes } from '../../utils/constants'

export const getFileIcon = file => {
  const type = file?.mimeType || file?.type
  let icon = faFile

  if (!type) {
    // Default icon
  } else if (type === FileTypes.PDF) {
    icon = faFilePdf
  } else if (type === FileTypes.PNG || type === FileTypes.JPG || type === FileTypes.JPEG || type === FileTypes.WEBP) {
    icon = faImage
  } else if (type === FileTypes.DOC || type === FileTypes.DOCX) {
    icon = faFileDoc
  } else if (type === FileTypes.EXCEL || type === FileTypes.XLSX) {
    icon = faFileExcel
  } else if (type === FileTypes.ZIP) {
    icon = faArchive
  }

  return icon
}

export const getFileSize = file => {
  const size = '0 B'

  if (file?.size > (1024 * 1024)) {

  } else if (file?.size > 1024) {
    return `${(file.size / 1024).toFixed(2)} KB`
  } else if (file?.size > 0) {
    return `${file.size} B`
  }

  return size
}

const FilePreview = ({ file, onRemove }) => {
  const previewImage = useMemo(() => getFileIcon(file), [file?.type])
  const fileSize = useMemo(() => getFileSize(file), [file?.size])

  return (
    <div className='file-preview-container flex-row ai-ctr jc-ctr pd-8'>
      <div className='mr-8'> <FontAwesomeIcon icon={previewImage} /> </div>
      <div className='text-ellipsis'> {file.name} </div>
      <div className='mr-8 ml-8'> <FontAwesomeIcon icon={faMinus} /> </div>
      <div style={{ minWidth: '70px' }}> {fileSize} </div>
      <div className='flex-fill' />
      <IconButton icon={faTimes} size='small' type='default' onClick={() => onRemove(file)} />
    </div>
  )
}

export default FilePreview
